// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__wM6VX","OrderButton":"BuildControls_OrderButton__2md1n","enable":"BuildControls_enable__IZVWC"};